module.exports = __webpack_public_path__ + "img/logo.b5f6150e.svg";